module.exports = __webpack_public_path__ + "img/SWP_Shield_06 (1).941aa5a9.png";